<template>
  <div class="processed-data-tree">
    <div v-if="!hasContent()">
      <b-card>
        {{ $t('FORMS.NOTHING') }}
      </b-card>
    </div>
    <div v-if="!dataPresent">
       <b-card id="nodatadisplay">
       No Records Found for the Current Search
     </b-card>
   </div>
   <div v-for="form in processedData" >
      <div v-if="form">
        <div v-for="sectionData in form.children" :key="sectionData.path">
          <div v-if="sectionData && sectionData.data_type === 'section'">
            <b-button @click="sectionData.show_section = !sectionData.show_section" id="mybutton" v-b-toggle="sectionData.key">
              <span class="when-opened"><i class="fa fa-minus-square" aria-hidden="true"></i></span>
              <span class="when-closed"><i class="fa fa-plus-square" aria-hidden="true"></i></span> {{sectionData.key}}
            </b-button>
            <b-collapse v-model="sectionData.show_section" :id="sectionData.key" class="mt-2">
              <b-card>
              <div v-for="data in sectionData.children" :key="data.path">
                <div v-if="data">
                  <!-- <div v-if="((data.key.toLowerCase()).includes(processValueText.toLowerCase()))"> -->
                    <div v-if="data.children">
                      <div v-if="data.data_type === 'logical' || data.data_type === 'npi'" :id="'group_' + data.path">
                        <b-card no-body>
                          <div slot="header" class="text-center" >
                            <strong @click="inputFocused(data.path)">{{ data.key | capitalize }}</strong>
                          </div>
                          <b-popover :target="'group_' + data.path" triggers="click" placement="top" boundary="window">
                            <div class="canvas-wrapper">
                              <canvas :id="'canvas_' + data.path"></canvas>
                            </div>
                          </b-popover>
                          <br>
                          <processed-data-tree :minConf="minConf" :maxConf="maxConf" :processedData="data.children" :dataBus="dataBus" :imgBase="imgBase" :imgUrl="imgUrl" v-bind:currentPage="currentPage" :docStatus="docStatus"></processed-data-tree>
                        </b-card>
                      </div>

                      <div v-if="data.data_type === 'combine_data'">
                        <processed-data-tree :minConf="minConf" :maxConf="maxConf" :processedData="[data]" :dataBus="dataBus" :imgBase="imgBase" :imgUrl="imgUrl" v-bind:currentPage="currentPage" :docStatus="docStatus" :dataPresent="true"></processed-data-tree>
                      </div>

                      <div v-else-if="data.data_type === 'single_select'">
                        <process-single-select-data :content="data" @focused="inputFocused" @dataUpdate="selectChanges" :imgBase="imgBase" :imgUrl="imgUrl" v-bind:currentPage="currentPage" :docStatus="docStatus"></process-single-select-data>
                      </div>

                      <div v-else-if="data.data_type === 'multi_select'">
                        <process-multi-select-data :content="data" @focused="inputFocused" @dataUpdate="selectChanges" :imgBase="imgBase" :imgUrl="imgUrl" v-bind:currentPage="currentPage" :docStatus="docStatus"></process-multi-select-data>
                      </div>

                      <div v-if="data.data_type === 'name'">
                        <processed-data-tree :minConf="minConf" :maxConf="maxConf" :processedData="[data]" :dataBus="dataBus" :imgBase="imgBase" :imgUrl="imgUrl" :processValueText="processValueText" :dataPresent="dataPresent" v-bind:currentPage="currentPage" :docStatus="docStatus"></processed-data-tree>
                      </div>

                      <div v-else-if="data.data_type === 'table_column' || data.data_type === 'table_row'">
                        <div slot="header" class="text-center mt-3">
                          <strong @click="inputFocused(data.path)">{{ data.key | capitalize }}</strong>
                          <b-button class="show-table" variant="secondary"
                                    @click="showTable(data.path)"
                                    v-b-tooltip.hover.right :title="$t('COMMON.SHOW_TABLE')">
                            <i class="fa fa-table" aria-hidden="true"></i>
                          </b-button>
                        </div>
                        <br>
                      </div>

                    </div>
                    <div v-else>
                      <div v-if="data.show_field">
                        <div v-if="data.data_type === 'signature'">
                          <b-form-group>
                            <b-row>
                              <b-col sm="8">
                                <div>
                                  <span >{{data.key | capitalize}}</span>
                                  <sup v-if="data.required" class="text-danger required-css">
                                    <i class="fa fa-asterisk"></i>
                                  </sup>
                                  <span v-if="data.status == 'pending'" class="badge" style="backgroundColor:rgb(195, 187, 187)">{{ $t('FORMS.PENDING') }}</span>
                                  <span v-else-if="data.status == 'approved'" class="badge badge-success">{{ $t('FORMS.APPROVED') }}</span>
                                  <span v-else-if="data.status == 'rejected'" class="badge badge-danger">{{ $t('FORMS.REJECTED') }}</span>
                                  <span v-if="data.chunk_edited" class="badge badge-edited"><i class="fa fa-check" aria-hidden="true"></i> {{ $t('FORMS.EDITED') }}</span>
                                </div>
                              </b-col>
                              <b-col sm="4" align="right">
                                <span v-b-tooltip.hover :title="$t('COMMON.APPROVE')">
                                  <a  class="btn text-success signature-actions"
                                      :class="{disabled: data.status === 'approved'}"
                                      @click="reviewField(data, 'approved')">
                                    <i class="icon-check"/>
                                  </a>
                                </span>
                                <span v-b-tooltip.hover :title="$t('COMMON.REJECT')">
                                  <a  class="btn text-danger signature-actions"
                                      :class="{disabled: data.status === 'rejected'}"
                                      @click="reviewField(data, 'rejected')">
                                    <i class="icon-close"/>
                                  </a>
                                </span>
                                <span v-b-tooltip.hover :title="$t('COMMON.RESIZE')">
                                  <a  class="btn text-primary signature-actions"
                                      :class="{disabled: data.show_actions}"
                                      @click="enableResize(data)">
                                    <i class="icon-crop"/>
                                  </a>
                                </span>
                                <!-- <a class="btn text-danger signature-actions" >
                                  <i class="icon-trash" v-b-tooltip.hover :title="$t('COMMON.DELETE')" @click="deleteConfirmModal(data)"/>
                                </a> -->
                              </b-col>
                            </b-row>
                            <b-row>
                              <b-col lg="12">
                                <b-img fluid alt="Signature Field" :src="'data:image/png;base64,' + data.current_img_enc"/>
                                </b-col>
                              </b-row>
                              <b-row>
                                <b-col lg="12" class="text-right" v-show="data.show_actions">
                                  <a class="btn btn-sm text-primary signature-edit" @click="saveResize(data)">{{ $t('COMMON.SAVE') }}</a>
                                  <a class="btn btn-sm text-secondary signature-edit" @click="resetResize(data)">{{ $t('COMMON.RESET') }}</a>
                                </b-col>
                              </b-row>
                          </b-form-group>
                        </div>
                        <div v-else-if="data.data_type === 'barcode'">
                          <b-form-group>
                            <b-input-group :id="data.path" >
                              <div class="input-group-prepend" @click="inputFocused(data.path)">
                                <span class="input-group-text">{{ data.key }}</span>
                              </div>
                              <b-form-input readonly type="text" state="true" v-model="data.original_value" @focus.native="inputFocused(data.path)"></b-form-input>
                            </b-input-group>
                          </b-form-group>
                        </div>
                        <div v-else-if="data.data_type === 'dropdown'">
                          <!-- <p>{{data}}</p> -->
                          <process-single-select :content="data" @focused="inputFocused" @dataUpdate="selectChanges" :imgBase="imgBase" :imgUrl="imgUrl"></process-single-select>
                        </div>
                        <div v-else-if="data.data_type === 'checkbox'">
                          <b-form-group>
                            <b-form-checkbox-group stacked id="basicCustomCheckboxes">
                              <div style="z-index: auto" class="custom-control custom-checkbox" @click="inputFocused(data.path)" @mouseover="inputFocused(data.path)" :id="'field_' + data.path">
                                <input type="checkbox" class="custom-control-input" :id="data.key" :value="data.key"
                                v-bind:true-value="'true'" v-bind:false-value="'false'" v-model="data.current_value" @change="checkChanged(data)">
                                <label class="custom-control-label" :for="data.key">{{ data.key | capitalize }}</label>
                                <sup v-if="data.required" class="text-danger required-css">
                                  <i class="fa fa-asterisk"></i>
                                </sup>
                                <span v-if="data.edited" class="badge badge-edited"><i class="fa fa-check" aria-hidden="true"></i> Edited</span>
                              </div>
                              <b-popover v-if="data.path.split('.')[0] === currentPage.toString()" :target="'field_' + data.path" triggers="hover" placement="top" boundary="window">
                                <div class="canvas-wrapper">
                                  <canvas :id="'canvas_' + data.path"></canvas>
                                </div>
                              </b-popover>
                            </b-form-checkbox-group>
                          </b-form-group>
                        </div>
                      <div v-else>
                        <div v-if="((data.confidence * 100 ) <= maxConf) && ((data.confidence * 100) >= minConf)">
                          <b-form-group>
                            <label for="name">
                              <span v-if="groupLabel">{{groupLabel}}</span>
                              <span v-else>{{data.header ? data.header : data.key | capitalize}}</span>
                              <sup v-if="data.required" class="text-danger required-css">
                                <i class="fa fa-asterisk"></i>
                              </sup>
                              <span v-if="data.current_value">
                                <span v-if="data.date_format"><i>({{data.date_format}})</i></span>
                                <span v-if="data.edited && !data.is_system_generated" class="badge" :style="{ color: '#FFFFFF', backgroundColor: '#170c9e' }" :title="$t('FORMS.CON_SCORE')">100</span>
                                <span v-else class="badge" :style="{ backgroundColor: data.color_code }" :title="$t('FORMS.CON_SCORE')">{{ Math.round(data.confidence * 100) }}</span>
                                <span v-if="data.edited && data.is_system_generated" class="badge" :style="{ backgroundColor: data.color_code }" :title="$t('FORMS.CON_SCORE')"></span>
                              </span>
                              <span v-if="data.is_system_generated" class="badge badge-edited">System Edited <i class="fa fa-exclamation" aria-hidden="true"></i></span>
                              <span v-if="data.edited" class="badge badge-edited"><i class="fa fa-check" aria-hidden="true"></i> Edited</span>
                              <span v-if="data.is_auto_correct && autoCorrectFlag" class="badge badge-auto-corrected"><i class="fa fa-check" aria-hidden="true"></i> Auto-Corrected</span>
                              <span v-else-if="data.auto_correct_enable && autoCorrectFlag" class="badge badge-auto_correct_enable"><i class="fa fa-check" aria-hidden="true"></i> Auto-Correct-Enable</span>
                            </label>
                            <div id="editLabel" v-if="isInsCard">
                              <i class="fa fa-pencil" v-b-modal.changeLabel @click="setLabelValue(data)"></i>
                            </div>
                            <content-editable :content="data" @update="inputChanged" @focused="inputFocused" :imgBase="imgBase" :imgUrl="imgUrl" :currentPage="currentPage" :docStatus="docStatus"></content-editable>
                          </b-form-group>
                        </div>
                      </div>
                      </div>
                    </div>
                  <!-- </div> -->
                </div>
              </div>
              </b-card>
            </b-collapse>
          </div>
          <div v-else>
            <div v-if="sectionData">
              <!-- <div v-if="((data.key.toLowerCase()).includes(processValueText.toLowerCase()))"> -->
                <div v-if="sectionData.children">
                  <div v-if="sectionData.data_type === 'logical' || sectionData.data_type === 'npi'" :id="'group_' + sectionData.path">
                    <b-card no-body>
                      <div slot="header" class="text-center" >
                        <strong @click="inputFocused(sectionData.path)">{{ sectionData.key | capitalize }}</strong>
                      </div>
                      <b-popover :target="'group_' + data.path" triggers="click" placement="top" boundary="window">
                        <div class="canvas-wrapper">
                          <canvas :id="'canvas_' + data.path"></canvas>
                        </div>
                      </b-popover>
                      <br>
                      <processed-data-tree :minConf="minConf" :maxConf="maxConf" :processedData="sectionData.children" :dataBus="dataBus" :imgBase="imgBase" :imgUrl="imgUrl" v-bind:currentPage="currentPage" :docStatus="docStatus"></processed-data-tree>
                    </b-card>
                  </div>

                  <div v-if="sectionData.data_type === 'combine_data'">
                    <processed-data-tree :minConf="minConf" :maxConf="maxConf" :groupLabel="sectionData.key" :processedData="[sectionData]" :dataBus="dataBus" :imgBase="imgBase" :imgUrl="imgUrl" v-bind:currentPage="currentPage" :docStatus="docStatus" :dataPresent="true"></processed-data-tree>
                  </div>

                  <div v-if="sectionData.data_type === 'name'">
                    <processed-data-tree :minConf="minConf" :maxConf="maxConf" :processedData="[sectionData]" :dataBus="dataBus" :imgBase="imgBase" :imgUrl="imgUrl" :processValueText="processValueText" :dataPresent="dataPresent" v-bind:currentPage="currentPage" :docStatus="docStatus"></processed-data-tree>
                  </div>

                  <div v-else-if="sectionData.data_type === 'single_select'">
                    <process-single-select-data :content="sectionData" @focused="inputFocused" @dataUpdate="selectChanges" :imgBase="imgBase" :imgUrl="imgUrl" v-bind:currentPage="currentPage" :docStatus="docStatus"></process-single-select-data>
                  </div>

                  <div v-else-if="sectionData.data_type === 'multi_select'">
                    <process-multi-select-data :content="sectionData" @focused="inputFocused" @dataUpdate="selectChanges" :imgBase="imgBase" :imgUrl="imgUrl" v-bind:currentPage="currentPage" :docStatus="docStatus"></process-multi-select-data>
                  </div>

                  <div v-else-if="sectionData.data_type === 'table_column' || sectionData.data_type === 'table_row'">
                    <div slot="header" class="text-center mt-3">
                      <strong @click="inputFocused(sectionData.path)">{{ sectionData.key | capitalize }}</strong>
                      <b-button class="show-table" variant="secondary"
                                @click="showTable(sectionData.path)"
                                v-b-tooltip.hover.right :title="$t('COMMON.SHOW_TABLE')">
                        <i class="fa fa-table" aria-hidden="true"></i>
                      </b-button>
                    </div>
                    <br>
                  </div>

                </div>
                <div v-else>
                  <div v-if="sectionData.show_field">
                    <div v-if="sectionData.data_type === 'signature'">
                      <b-form-group>
                        <b-row>
                          <b-col sm="8">
                            <div>
                              <span >{{sectionData.key | capitalize}}</span>
                              <sup v-if="sectionData.required" class="text-danger required-css">
                                <i class="fa fa-asterisk"></i>
                              </sup>
                              <span v-if="sectionData.status == 'pending'" class="badge" style="backgroundColor:rgb(195, 187, 187)">{{ $t('FORMS.PENDING') }}</span>
                              <span v-else-if="sectionData.status == 'approved'" class="badge badge-success">{{ $t('FORMS.APPROVED') }}</span>
                              <span v-else-if="sectionData.status == 'rejected'" class="badge badge-danger">{{ $t('FORMS.REJECTED') }}</span>
                              <span v-if="sectionData.chunk_edited" class="badge badge-edited"><i class="fa fa-check" aria-hidden="true"></i> {{ $t('FORMS.EDITED') }}</span>
                            </div>
                          </b-col>
                          <b-col sm="4" align="right">
                            <span v-b-tooltip.hover :title="$t('COMMON.APPROVE')">
                              <a  class="btn text-success signature-actions"
                                  :class="{disabled: sectionData.status === 'approved'}"
                                  @click="reviewField(sectionData, 'approved')">
                                <i class="icon-check"/>
                              </a>
                            </span>
                            <span v-b-tooltip.hover :title="$t('COMMON.REJECT')">
                              <a  class="btn text-danger signature-actions"
                                  :class="{disabled: sectionData.status === 'rejected'}"
                                  @click="reviewField(sectionData, 'rejected')">
                                <i class="icon-close"/>
                              </a>
                            </span>
                            <span v-b-tooltip.hover :title="$t('COMMON.RESIZE')">
                              <a  class="btn text-primary signature-actions"
                                  :class="{disabled: sectionData.show_actions}"
                                  @click="enableResize(sectionData)">
                                <i class="icon-crop"/>
                              </a>
                            </span>
                            <!-- <a class="btn text-danger signature-actions" >
                              <i class="icon-trash" v-b-tooltip.hover :title="$t('COMMON.DELETE')" @click="deleteConfirmModal(sectionData)"/>
                            </a> -->
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col lg="12">
                            <b-img fluid alt="Signature Field" :src="'data:image/png;base64,' + sectionData.current_img_enc"/>
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col lg="12" class="text-right" v-show="sectionData.show_actions">
                              <a class="btn btn-sm text-primary signature-edit" @click="saveResize(sectionData)">{{ $t('COMMON.SAVE') }}</a>
                              <a class="btn btn-sm text-secondary signature-edit" @click="resetResize(sectionData)">{{ $t('COMMON.RESET') }}</a>
                            </b-col>
                        </b-row>
                      </b-form-group>
                    </div>
                    <div v-else-if="sectionData.data_type === 'barcode'">
                      <b-form-group>
                        <b-input-group :id="sectionData.path" >
                          <div class="input-group-prepend" @click="inputFocused(sectionData.path)">
                            <span class="input-group-text">{{ sectionData.key }}</span>
                          </div>
                          <b-form-input readonly type="text" state="true" v-model="sectionData.original_value" @focus.native="inputFocused(sectionData.path)"></b-form-input>
                        </b-input-group>
                      </b-form-group>
                    </div>
                    <div v-else-if="sectionData.data_type === 'checkbox'">
                      <b-form-group>
                        <b-form-checkbox-group stacked id="basicCustomCheckboxes">
                          <div style="z-index: auto" class="custom-control custom-checkbox" @click="inputFocused(sectionData.path)" @mouseover="inputFocused(sectionData.path)" :id="'field_' + sectionData.path">
                            <input type="checkbox" class="custom-control-input" :id="sectionData.key" :value="sectionData.key"
                            v-bind:true-value="'true'" v-bind:false-value="'false'" v-model="sectionData.current_value" @change="checkChanged(sectionData)">
                            <label class="custom-control-label" :for="sectionData.key">{{ sectionData.key | capitalize }}</label>
                            <sup v-if="sectionData.required" class="text-danger required-css">
                              <i class="fa fa-asterisk"></i>
                            </sup>
                            <span v-if="sectionData.edited" class="badge badge-edited"><i class="fa fa-check" aria-hidden="true"></i> Edited</span>
                          </div>
                          <!-- <b-popover :target="'field_' + data.path" triggers="hover" placement="right" boundary="window">
                            <div class="canvas-wrapper">
                              <canvas :id="'canvas_' + data.path"></canvas>
                            </div>
                          </b-popover> -->
                        </b-form-checkbox-group>
                      </b-form-group>
                    </div>
                    <div v-else>
                      <div v-if="((sectionData.confidence * 100 ) <= maxConf) && ((sectionData.confidence * 100) >= minConf)">
                        <b-form-group>
                          <label for="name">
                            <span v-if="groupLabel">{{groupLabel}}</span>
                            <span v-else>{{sectionData.header ? sectionData.header : sectionData.key | capitalize}}</span>
                            <sup v-if="sectionData.required" class="text-danger required-css">
                              <i class="fa fa-asterisk"></i>
                            </sup>
                            <span v-if="sectionData.current_value">
                              <span v-if="sectionData.date_format"><i>({{sectionData.date_format}})</i></span>
                              <span v-if="sectionData.edited && !sectionData.is_system_generated" class="badge" :style="{ color: '#FFFFFF', backgroundColor: '#170c9e' }" :title="$t('FORMS.CON_SCORE')">100</span>
                              <span v-else class="badge" :style="{ backgroundColor: sectionData.color_code }" :title="$t('FORMS.CON_SCORE')">{{ Math.round(sectionData.confidence * 100) }}</span>
                              <span v-if="sectionData.edited && sectionData.is_system_generated" class="badge" :style="{ color: '#FFFFFF', backgroundColor: '#170c9e' }" :title="$t('FORMS.CON_SCORE')"></span>
                            </span>
                            <span v-if="sectionData.is_system_generated" class="badge badge-edited">System edited <i class="fa fa-exclamation" aria-hidden="true"></i></span>
                            <span v-if="sectionData.edited" class="badge badge-edited"><i class="fa fa-check" aria-hidden="true"></i> Edited</span>
                            <span v-if="sectionData.is_auto_correct && autoCorrectFlag" class="badge badge-auto-corrected"><i class="fa fa-check" aria-hidden="true"></i> Auto-Corrected</span>
                            <span v-else-if="sectionData.auto_correct_enable && autoCorrectFlag" class="badge badge-auto_correct_enable"><i class="fa fa-check" aria-hidden="true"></i> Auto-Correct-Enable</span>
                          </label>
                          <div id="editLabel" v-if="isInsCard">
                            <i class="fa fa-pencil" v-b-modal.changeLabel @click="setLabelValue(sectionData)"></i>
                          </div>
                          <content-editable :content="sectionData" @update="inputChanged" @focused="inputFocused" :imgBase="imgBase" :imgUrl="imgUrl" :currentPage="currentPage" :docStatus="docStatus"></content-editable>
                        </b-form-group>
                      </div>
                    </div>
                  </div>
                </div>
              <!-- </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="changeLabel" :title="$t('FORMS.CHANGE_LABEL')" ref="changeLabelModal" hide-header-close centered>
      <b-card class="mb-0">
        <b-row class="form-group">
          <b-col cols="12">
            <b-form-group :label="$t('FORMS.LABEL_NAME')" label-for="labelName">
              <b-form-input id="labelName"
                :class="{'is-invalid': $v.newLabelName.$invalid, 'is-valid': !$v.newLabelName.$invalid}"
                type="text" :placeholder="selectedLabel.key"
                v-model="newLabelName">
                @blur="$v.newLabelName.$touch()"
              </b-form-input>
              <b-form-invalid-feedback v-if="!$v.newLabelName.required">{{ $t('FORMS.REQ_LABEL') }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card>
      <div slot="modal-footer">
        <b-btn size="sm" variant="secondary" @click="changeName" :disabled="!$v.newLabelName.required"> {{ $t('COMMON.CHANGE') }} </b-btn>
        <b-btn size="sm" variant="light" @click="hideChangeModal"> {{ $t('COMMON.CANCEL') }} </b-btn>
      </div>
    </b-modal>
    <b-modal :title="$t('COMMON.DELETE_CONFIRM')" class="modal-danger" ref="fieldDeleteModal" :ok-title="$t('COMMON.YES')" :cancel-title="$t('COMMON.NO')" @ok="deleteField" ok-variant="danger">
      {{ $t('FORMS.DELETE_CONTENT', {'FIELD_NAME': selectedFieldKey}) }}
      Do you want to delete <strong> {{ selectedFieldKey }} </strong> field?
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import Multiselect from 'vue-multiselect'
import dateField from '@/components/process/dateField'
import ContentEditable from '@/components/utils/contentEditable'
import processMultiSelectData from '@/components/process/processMultiSelectData'
import processSingleSelectData from '@/components/process/processSingleSelectData'
import { required } from 'vuelidate/lib/validators'

export default {
  components: { Multiselect, ContentEditable, processMultiSelectData, processSingleSelectData, dateField },
  props: ['processedData', 'autoCorrectFlag', 'dataBus', 'isInsCard', 'groupLabel', 'minConf', 'maxConf', 'imgBase', 'currentPage', 'imgUrl', 'dataPresent', 'processValueText', 'docStatus'],
  name: 'processed-data-tree',
  data () {
    return {
      selectedPvId: '',
      selectedFieldKey: {},
      newLabelName: null,
      selectedLabel: { id: null, key: null }
    }
  },
  computed: {
    borderColor: function () {
      return (edited, colorCode) => edited ? null : colorCode
    },
    isNewField: function () {
      return this.selectedLabel.new_record === undefined
    }
  },
  validations: {
    newLabelName: {
      required
    }
  },
  methods: {
    showTable (path) {
      this.dataBus.$emit('showTable', path)
    },
    inputChanged: function (data) {
      let updateData = [ {id: data.content.pv_id, key: data.content.key, new_record: data.content.new_record, form_id: data.content.form_id, current_value: data.newValue} ]
      let newValue = data.newValue.trim()
      let originalValue = data.content.original_value ? data.content.original_value.trim() : ''
      if (newValue !== originalValue) {
        data.content.edited = true
        data.content.is_system_generated = false
      } else {
        data.content.edited = false
      }
      this.dataBus.$emit('updateData', updateData)
    },

    checkChanged: function (data) {
      let updateData = [ {id: data.pv_id, key: data.key, current_value: data.current_value} ]
      if (data.current_value !== data.original_value) {
        data.edited = true
        data.is_system_generated = false
      } else {
        data.edited = false
      }
      this.dataBus.$emit('updateData', updateData)
    },

    showFieldCanvas: function (imgBase, imgUrl, path) {
      let selectedNode = this.processedData.filter((node) => {
        return (path === node.path)
      })
      let { x_pos: x, y_pos: y, width, height } = selectedNode
      var canvas = document.getElementById('canvas_' + path)
      if (canvas) {
        if (height / 50 > 4) {
          canvas.parentElement.style.maxHeight = '100px'
          canvas.style.maxHeight = height / 4 + 'px'
        } else {
          canvas.parentElement.style.maxHeight = '75px'
          canvas.style.maxHeight = '50px'
        }
        canvas.height = height
        canvas.width = width
        var image = new window.Image()
        image.src = imgBase + imgUrl
        var ctx = canvas.getContext('2d')
        image.onload = function () {
          ctx.drawImage(image, x, y, width, height, 0, 0, width, height)
        }
      }
    },

    inputFocused: function (path) {
      this.dataBus.$emit('setFocus', path)
      this.showFieldCanvas(this.imgBase, this.imgUrl, path)
    },

    selectChanges: function (data) {
      this.dataBus.$emit('updateData', data)
    },

    hasContent: function () {
      return this.processedData && this.processedData.length > 0
    },

    reviewField (data, status) {
      let updateData = [ {id: data.pv_id, status: status} ]
      this.dataBus.$emit('updateData', updateData)
      data.status = status
    },

    enableResize (data) {
      this.dataBus.$emit('enableResize', data.path)
      data.show_actions = true
    },

    saveResize (data) {
      this.dataBus.$emit('saveResize', data)
      data.chunk_edited = true
      data.show_actions = false
    },

    resetResize (data) {
      this.dataBus.$emit('resetResize')
      data.show_actions = false
    },

    deleteConfirmModal (data) {
      this.selectedPvId = data.pv_id
      this.selectedFieldKey = data.key
      this.$refs.fieldDeleteModal.show()
    },

    deleteField () {
      this.dataBus.$emit('deleteData', this.selectedPvId)
      this.selectedPvId = ''
      this.selectedFieldKey = ''
    },

    setLabelValue (data) {
      this.selectedLabel = data
      this.newLabelName = data.key
    },

    hideChangeModal: function () {
      this.$refs.changeLabelModal.hide()
    },

    changeName: function () {
      if (this.isNewField) {
        let updateData = new window.FormData()
        updateData.append('label_name', this.newLabelName)
        Vue.axios.patch('/processed_values/' + this.selectedLabel.pv_id + '/update_label', updateData, { headers: { Authorization: `Bearer ${this.idToken}` } })
          .then(response => {
            Vue.toasted.show(this.$t('FORMS.MSG_LABEL'))
          }, error => {
            console.error(error)
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'))
          })
      }
      this.selectedLabel.key = this.newLabelName
      this.$refs.changeLabelModal.hide()
    }
  }
}
</script>

<style scoped>
.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
  display: none;
}
.form-group {
    margin-bottom: 0.3rem;
}
label {
    display: inline-block;
    margin-bottom: 0px;
}
.signature-actions, .signature-edit {
  padding: 0px;
}

#nodatadisplay {
 color: red;
  background-color: Transparent;
 font-size: large;
}
#mybutton {
  background-color: Transparent;
  background-repeat:no-repeat;
  border: none;
  cursor:pointer;
  overflow: hidden;
  outline:none;
  color: #000000;
}
#mybutton:focus {
  box-shadow: none;
}

#editLabel {
  display: inline;
  float: right;
  color: #170c9e;
  cursor: pointer;
  margin-right: .5em
}

.required-css {
  padding: 1px;
  margin-right: -4px;
  left: -0.3em;
}

.show-table {
  margin-left: 10px;
  padding: 2px 7px;
  border-radius: 6px;
}

.canvas-wrapper {
  max-width: 200px;
  padding: 5px;
  overflow: auto;
}

::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgb(183, 184, 185);
    -webkit-box-shadow: 0 0 1px rgba(255,255,255,.5);
}
</style>



// WEBPACK FOOTER //
// src/components/process/processedDataTree.vue